export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}

export function getI18n(gender: Gender) {
  switch (gender) {
    case Gender.MALE:
      return "Global.Gender.Male";
    case Gender.FEMALE:
      return "Global.Gender.Female";
    case Gender.OTHER:
      return "Global.Gender.Other";
  }
}
